import { computed, type Ref } from 'vue';

export function useTextCounter(text: Ref<string>) {
  // Remove tags and line break from count
  const counter = computed<number>(() => text.value.replace(/<[^>]*>|\r?\n/g, '').length);

  return {
    counter,
  };
}
